module.exports = __webpack_public_path__ + "static/media/Lato-Semibold.8bb939ef.eot";